module.exports = __webpack_public_path__ + "img/STERiGLIDE_04_02.f86a0f39.jpg";